module.exports = __webpack_public_path__ + "static/media/quail-forever.bb743694.png";